module.exports = {
  search: 'Search',
  isCustomer: 'Customer',
  isBookingAgent: 'Booking agent',
  isOverseaAgent: 'POD agent',
  isDesignationAgent: 'RO agent	\u3000',
  isLocalAgent: 'Local agent',
  isSeaCmp: 'Shipping Lines\u3000',
  isAirCmp: 'Air lines',
  isCustomsBroker: 'Customs broker',
  isTruckCmp: 'Trucking',
  isWarehouse: 'Warehouse',
  isGlobal: 'Group',
  isShipper: 'Shipper',
  isConsignee: 'Consignee',
  isNotify: 'Notify',
  isActive: 'Activated',
  isShowHq: 'Whether to display HQ customer',
  btMerge: 'MERGE',
  btnRemove: 'DELETE',
  btnAdd: 'CREATE',
  btnLookUp: 'VIEW',
  btnRefresh: 'REFRESH',
  totalCount: 'Total Count',
  btAudit: 'AUDIT',
  btCacelAudit: 'CANCEL AUDIT',
  approvedState: 'Approved State',
  approvedBy: 'Approved User',
  dateApproved: 'Date Approved',
  dateCreated: 'Date Created',
  to: 'To',
  dateModified: 'Date Modified',
  parter: 'Parter',
  customerType: 'Customer Type',
  sales: 'Sales',
  customerLevel: 'Customer Level',
  whetherReview: 'Whether Review',
  whetherEffective: 'Whether Effective',
  amount: 'Amount',
  query: 'Query',
  add: 'add',
  delete: 'delete',
  view: 'View',
  review: 'Review',
  batchPrint: 'Batch Print',
  B2BRegistrationInvitation: 'B2B Registration Invitation',
  freightAuthorization: 'Freight Authorization',
  combine: 'Combine',
  batchEditInvoiceHeader: 'Batch edit Invoice Header',
  batchEditSalers: 'Batch edit SalesMan',
  batchEditServer: 'Batch edit service staff',
  templateDownload: 'Template Download',
  import: 'Import',
  downloadImportTemplate: 'Download Import Template',
  downloadImportResults: 'Download Import Results',
  number: 'Number',
  abbreviation: 'Abbreviation',
  code: 'CODE',
  chineseName: 'Chinese Name',
  englishName: 'English Name',
  branchCompany: 'Branch Company',
  creator: 'Creator',
  creationDate: 'Creation Date',
  modifier: 'Modifier',
  modificationDate: 'Modification Date',
  ecommerceCustomer: 'Ecommerce Customer',
  day30day: '30 Days(Bill)',
  day60day: '60 Days(Bill)',
  day90day: '90 Days(Bill)',
  gt90day: 'Greater Than 90 Days(Bill)',
  all: 'All',
  yes: 'Yes',
  no: 'No',
  return: 'Return',
  edit: 'edit',
  save: 'Save',
  cancel: 'Cancel',
  basicInformation: 'Basic Information',
  contacts: 'Contacts',
  customer: 'Customer',
  creditAccount: 'Credit Account',
  contractNumber: 'Contract Number',
  documentation: 'Documentation',
  doorInformation: 'Door Information',
  specialRequirements: 'Special Requirements',
  invoicingRequirements: 'Invoicing Requirements',
  destinationPortHandlingAgent: 'Destination Port Handling Agent',
  destinationNominatedAgent: 'Destination Nominated Agent',
  portLocation: 'Port Location',
  spaceCarrier: 'Space Carrier',
  spaceAgent: 'Space Agent',
  warehouseInformation: 'Warehouse information',
  EDIConfiguration: 'EDI Configuration',
  AddressInformation: 'Address Information',
  BranchAuthorization: 'Branch authorization',
  activity: 'Activate',
  clearInactiveReasonFirst: 'Please clear the inactive reason first',
  inactiveReason: 'Inactive reason',
  crossTenantAuthorize: 'Cross Tenant Authorize',
  crossTenantAuthorizeAgreement: 'Cross Tenant Authorize Agreement',
  agree: 'Agree',
  theOtherPlatformID: 'The Other Platform ID',
  seaCmpAgent: 'SeaCmpAgent',
  destinationAgent: 'Destination Agent',
  nominatedAgent: 'Nominated Agent',
  localAgent: 'Local Agent',
  settlementAgent: 'Settlement Agent',
  shippingCompany: 'Shipping Company',
  airlineCompany: 'Airline Company',
  customsBroker: 'Customs Broker',
  warehouse: 'Warehouse',
  truckCompany: 'Truck Company',
  shipper: 'Shipper',
  consignee: 'Consignee',
  notify: 'Notify',
  others: 'Others',
  relatedBusinessType: 'Related Business Type',
  oceanExport: 'Ocean Export',
  oceanImport: 'Ocean Import',
  airExport: 'Air Export',
  airImport: 'Air Import',
  relatedBranch: 'Related Branch',
  paymentType: 'Payment Type',
  whetherCollection: 'Whether Collection',
  usingSettlementAgent: 'Using Settlement Agent',
  country: 'Country(Area)',
  province: 'Province',
  city: 'City',
  district: 'District',
  address: 'Address',
  postCode: 'Post Code',
  telephone: 'Telephone',
  fax: 'Fax',
  website: 'Website',
  rmbAccount: 'RMB Account',
  usdAccount: 'USD Account',
  taxRate: 'Tax Rate',
  additionalDescription: 'Additional Description',
  tel: 'Tel',
  sapCustomerCode: 'SAP Customer Code',
  sapSupplierCode: 'SAP Supplier Code',
  isSignContract: 'Sign a Contract',
  ContractStatus: 'Contract Status',
  ClientContractStatus: 'Client Contract Status',
  SupplierContractStatus: 'Supplier Contract Status',
  OverseasAgencyContractStatus: 'Overseas Agency Contract Status',
  OtherContractStatus: 'Other Contract Status',
  ContractApproxStatus: 'Contract Approx Status',
  name: 'Name',
  function: 'Function',
  isDefault: 'IsDefault',
  Email: 'Email',
  mobile: 'Mobile',
  remark: 'Remark',
  airline: 'Airline',
  departmentBelonging: 'Department Belonging',
  peers: 'Peers',
  isPeers: 'Is peers',
  introductionDate: 'i-trace Introduction Date',
  customerSpace1: 'Cargo sales type',
  customerSpace2: 'Nominated Cargo',
  customerSpace3: 'Free Hand',
  portOfDestination: 'Port of Destination',
  theCorrespondingServicePartners: 'The Corresponding Service Partners',
  theCorrespondingServiceOverseaAgent: 'The Corresponding Service OverseaAgent',
  positionType: 'Position Type',
  businessType: 'Business Type',
  user: 'User',
  creditControlSettings: 'Credit Control Settings',
  defaultCreditInfoSettings: 'Default message control maintenance',
  defaultCreditInfoNote: 'Note: After maintaining the default credit control, when a new partner is created in the system, the default credit control will take the currently maintained credit control content!',
  dateType: 'Date Type',
  settlementMethod: 'Settlement Method',
  monthlySettlement: 'Monthly Settlement',
  blacklist: 'Blacklist',
  accountPeriod: 'Account Period',
  limit: 'Limit',
  settlementType: 'Settlement Type',
  settlementByBill: 'Settlement By Bill',
  settlementNotByBill: 'Settlement Not By Bill',
  revenueAndExpenditureType: 'Revenue and Expenditure Type',
  collections: 'Collections',
  payment: 'Payment',
  depositAmount: 'Deposit Amount',
  revenueAndExpenditureDate: 'Revenue and Expenditure Date',
  revenueAndExpenditureMethod: 'Revenue and Expenditure Method',
  cash: 'Cash',
  depositCurrency: 'Deposit Currency',
  day: 'Day',
  week: 'Week',
  month: 'Month',
  space1: 'BusinessDate',
  space2: 'InvoiceDate',
  space3: 'CalculateByWeek',
  space4: 'ADesignatedDateMonthly',
  space5: 'SettlementByHalfMonth',
  space6: 'Cheque',
  space7: 'Transfer',
  space8: 'PromissoryNotes',
  space9: 'DelegateCollectionAndPayment',
  space10: 'BankCredit',
  effectiveDate: 'Effective Date',
  expiryDate: 'Expiry Date',
  fileNumber: 'File Number',
  remarks: 'Remarks',
  documentSize: 'Number of accessories',
  attachment: 'Attachment',
  uploadFile: 'Upload File',
  upload: 'Upload',
  download: 'Download',
  fileName: 'File Name',
  fileType: 'File Type',
  fileFormat: 'File Format',
  fileSize: 'File Size',
  viewFile: 'View File',
  whetherUploadContractAttachment: 'Whether to upload the contract attachment',
  doorName: 'Door Name',
  contact: 'Contact',
  doorAddress: 'Door Address',
  canOverPrice: 'Whether Invoice can Over Price',
  invoicingMethod: 'Invoicing Method',
  invoicingPerBill: 'Invoicing Per Bill',
  invoicingPerMonth: 'Invoicing per Month',
  invoicingNote: 'Invoicing Note',
  invoiceHeader: 'Invoice Header',
  registrationNumber: 'Taxpayer ID',
  invoiceAddress: 'Invoice Address',
  bankOfInvoiceHeader: 'Bank of Invoice Header',
  operation: 'Operation',
  bankMaintenance: 'Bank Maintenance',
  confirm: 'Confirm',
  currency: 'Currency',
  bankName: 'Bank Name',
  bankAccount: 'Bank Account',
  forecastReceivingEmail: 'Forecast Receiving E-Mail Address',
  oceanBillOfLadingAddress: 'Shipping Bill of Lading Address',
  airBillOfLadingAddress: 'Air Waybill Address',
  agentLevel: 'Agent Level',
  networkManager: 'Network Manager',
  billingAddress: 'Billing Address',
  network: 'Network',
  portName: 'Port Name',
  carrier: 'Carrier',
  carrierType: 'Carrier Type',
  bookingMethod: 'Booking Method',
  choose: 'Please Choose',
  bookingAgent: 'Booking Agent',
  ediSenderCode: 'EDI Sender Code',
  ediReceiverCode: 'EDI Receiver Code',
  bookingPartyCode: 'Booking Party Code',
  loadFailed: 'loadFailed',
  deleteing: 'deleting....',
  deleted: 'delete successfully',
  occurredError: 'occur an error',
  deleteConfirmTitle: 'deleteConfirm',
  deleteConfirmMessage: 'do you confirm to delete this airline message ?',
  formatInformation: 'Format Information',
  notFormatInformation: 'Not Format Information',
  formatSynchronize: 'Format Synchronize',
  codeAbbreviation: 'Code Abbreviation',
  enterpriseCode: 'Enterprise Code',
  partnerName: 'PartnerName',
  detailAddress: 'Detail Address',
  phone: 'Phone',
  email: 'Email',
  relexNumber: 'RelexNumber',
  cityName: 'CityName',
  provinceCode: 'ProvinceCode',
  provinceName: 'ProvinceName',
  postalCode: 'PostalCode',
  countryCode: 'CountryCode',
  aeoEnterpriseCode: 'AEO EnterpriseCode',
  specificContactName: 'Specific ContactName',
  specificContactPhone: 'Specific ContactPhone',
  specificContactAddress: 'Specific ContactAddress',
  specificContactRelexNumber: 'Specific ContactRelexNumber',
  WarehouseType: 'Warehouse type',
  WarehouseName: 'Warehouse name',
  WarehouseAddress: 'Warehouse address',
  WarehouseMap: 'Warehouse map',
  PleaseSelect: 'Please Select',
  Number: 'Number',
  GreaterThan: 'GreaterThan',
  LessThan: 'LessThan',
  EqualTo: 'Equal',
  WhetherToPushSOPStatus: 'Whether To Push SOP Status',
  Push: 'Push',
  NoPushing: 'No Pushing',
  portAgent: 'PortAgent',
  forwardingAgent: 'ForwardingAgent',
  loadingPlaceCompany: 'LoadingPlaceCompany',
  signBillPlaceCompany: 'SignBillPlaceCompany',
  dischargePortCompany: 'DischargePortCompany',
  destinationPortCompany: 'DestinationPortCompany',
  ParentCompany: 'ParentCompany',
  SelectFile: 'Select File',
  DeleteFile: 'Delete File',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  FileName: 'FileName',
  FileType: 'FileType',
  FileSize: 'FileSize',
  Uploader: 'Uploader',
  UploadTime: 'UploadTime',
  UploadProgress: 'UploadProgress',
  DocumentType: 'DocumentType',
  UnselectedContact: 'UnselectedContact',
  PartnerNotSaved: 'PartnerNotSaved',
  UpdateMaterial: 'UpdateMaterial',
  DataNotSelected: 'DataNotSelected',
  RailwayExport: 'RailwayExport',
  RefuseRemark: 'RefuseRemark',
  Refuser: 'Refuser',
  RefuseDate: 'Reject date',
  REMARKS: 'REMARKS',
  InternalRemark: 'Internal equipment note',
  supplyChainLines: 'supply chain lines',
  Middleman: 'Middleman',
  Factory: 'Factory',
  CompanyName: 'Company name',
  Company: 'Company',
  contacts_name: 'Contacts name',
  contacts_function: 'Contacts function',
  contacts_telephone: 'Contacts telephone',
  contacts_email: 'Contacts email',
  contacts_mobile: 'Contacts mobile',
  contacts_remark: 'Contacts remark',
  credit_creditControlSettings: 'Credit Control Settings',
  credit_dateType: 'Date Type',
  credit_creditControlSettings_date: 'Date type of credit control setting',
  credit_creditControl_date: 'Date type of credit control',
  credit_settlementMethod: 'Settlement Method',
  credit_monthlySettlement: 'Monthly Settlement',
  credit_blacklist: 'Blacklist',
  credit_accountPeriod: 'Account Period',
  credit_limit: 'Limit',
  credit_settlementType: 'Settlement Type',
  credit_settlementByBill: 'Settlement By Bill',
  credit_settlementNotByBill: 'Settlement Not By Bill',
  credit_revenueAndExpenditureType: 'Revenue and Expenditure Type',
  credit_collections: 'Collections',
  credit_payment: 'Payment',
  credit_depositAmount: 'Deposit Amount',
  credit_revenueAndExpenditureDate: 'Revenue and Expenditure Date',
  credit_revenueAndExpenditureMethod: 'Revenue and Expenditure Method',
  credit_cash: 'Cash',
  credit_depositCurrency: 'Deposit Currency',
  credit_additionalDescription: 'Additional Description',
  credit_day: 'Day',
  credit_week: 'Week',
  credit_month: 'Month',
  credit_space1: 'JobDate',
  credit_space2: 'InvoiceDate',
  credit_space3: 'CalculateByWeek',
  credit_space4: 'ADesignatedDateMonthly',
  credit_space5: 'SettlementByHalfMonth',
  credit_space6: 'Cheque',
  credit_space7: 'Transfer',
  credit_space8: 'PromissoryNotes',
  credit_space9: 'DelegateCollectionAndPayment',
  credit_space10: 'BankCredit',
  partnerReview: 'Partner review',
  partnerReviewed: 'Partner reviewed',
  fillRejectReason: 'Please fill in the reason for rejection',
  auditRejected: 'Audit rejected',
  changeServicePersonnel: 'Change service personnel',
  userName: 'User name',
  batchChangeSales: 'Batch change sales results',
  positionTypeNotSelected: 'Position type is not selected.',
  multipleSameBusinessPosition: 'There are multiple records of the same business position',
  defaultValueNotEmpty: 'The default value cannot be empty!',
  setInitialPassword: 'Set initial password',
  openB2BAccount: 'Open B2B account',
  openB2BSettings: 'Open B2B Settings',
  selectBookingAgent: 'Please select the corresponding booking agent!',
  batchSelectBookingAgent: 'Please select the corresponding booking agents!',
  modificationOfBookingAgents: 'Batch modify booking agents',
  resetPassword: 'reset password',
  b2bUsers: 'B2B users',
  selectNotOpenedB2BAccount: 'Please select a contact who has not opened a B2B account',
  emailAddressIsIllegal: 'Your email address is illegal!',
  selectAnApprovedPartner: 'Please select an approved partner',
  inputAPassword: 'Please input a password!',
  accountOpenedSuccessfully: 'Account opened successfully!',
  selectAContact: 'Please select a contact',
  oneContactPasswordCanResetATime: "Only one contact's password can be reset at a time",
  notOpenedB2BAccount: 'This contact has not opened a B2B account',
  confirmToReset: 'Confirm to reset',
  yourLoginPassword: ' login password?',
  openResetPasswordLink: 'Reset succeeded. Please open the reset password link in the mailbox to reset.',
  batchModifyServicePersonnel: 'Batch modify service personnel',
  exportModificationResults: 'Export modification results',
  partnerAbbreviation: 'Partner abbreviation',
  chineseNameOfPartner: 'Chinese name of partner',
  servicePersonal: 'service personal',
  isItSuccessful: 'Is it successful',
  enterUserInformation: 'Please enter user information',
  selectAUserToModify: 'Please select a user to modify',
  modifyInvoicingHeader: 'Modify Invoicing header',
  batchModifyInvoicingHeader: 'Batch modify Invoicing heade',
  enterBillingHeaderInformation: 'Please enter billing header information',
  batchChangeSalesperson: 'Batch change salesperson',
  modifySalesperson: 'Modify salesperson',
  batchModifySalesperson: 'Batch modify salesperson',
  salesman: 'salesman',
  selectRecordToExport: 'Please select the record to export!',
  mergedPartners: 'Merged partners',
  notPermissionEditOverseasAgent: 'You do not have permission to edit overseas agent!',
  notPermissionEditCarrier: 'You do not have permission to edit the carrier!',
  companyIsSettlementAgentFollowingPartners: 'This company is now the settlement agent of the following partners',
  confirmDisassociateAndSaveModification: 'Are you sure to disassociate and save the modification',
  affiliatedBranch: 'Affiliated branch',
  contractAffiliatedBranch: 'Contract affiliated branch',
  alreadyAPartner: 'Are you already a partner',
  selectAPartner: 'Please select a partner!',
  applicationSentSuccessfully: 'Application has been sent successfully!',
  addPlatformCertificationPartners: 'Add platform certification partners, interact with "wolian home" and build a logistics ecosystem.',
  tariffLevelAuthorization: 'Tariff level authorization',
  fullContainerFreightRate: 'Full container freight rate',
  lclFreightRate: 'LCL freight rate',
  airFreightRate: 'Air freight quote',
  fbaRate: 'FBA quote',
  mergePartners: 'Merge partners',
  updateSupplierData: 'Update supplier data',
  maintainInformation: 'Maintain information control in batches',
  batchBlacklistSetting: 'Batch blacklist setting',
  maintainDefaultCreditInfo: 'Default Credit Info',
  freightFateLevelIsAuthorized: 'The freight rate level is authorized to customer groups, not individuals',
  servicePersonnelSettingNotEnabled: 'The service personnel setting corresponding to the partner is not enabled',
  deletedWithAdministratorPermission: 'Can only be deleted with administrator permission!',
  partnerNotSelected: 'Partner not selected',
  partnerBeenUsedByBusiness: 'The partner has been used by the business',
  mergedPartnerBeenAssociatedWithCRM: 'The merged partner has been associated with CRM',
  mergedPartnerBeenAssociatedWithCRM1: 'The merged partner has been associated with CRM, {0}, after the dissolution of the partner can go to the "Customer Recycle Bin" menu to view.',
  mergedPartnerBeenAssociatedWithCRM2: 'The association relationship is forcibly disassociated',
  removeAssociationWithPartner: 'Please go to [sales - this group of customers] / [sales - customer high seas] to remove the association with the partner.',
  partnersWithCustomerAttributeCanBeSelected: 'Only partners with customer attribute can be selected',
  partnersWithOverseaAgentAttributeCanBeSelected: 'Only partners with the attribute of having an overseas agent can be selected.',
  authorizationSucceeded: 'Authorization succeeded',
  groupCompaniesCannotBeMerged: 'Group companies cannot be merged!',
  chooseADifferentPartner: 'Please choose a different partner!',
  noAuthorityToAuditCustomerRolePartners: 'No authority to audit customer role partners!!!',
  noAuthorityToAuditSupplierRolePartners: 'No authority to audit supplier role partners!!!',
  vouchersBeenGeneratedContinue: 'Vouchers have been generated. Continue to consolidate?',
  mergeSuccessful: 'Merge successful',
  uploadXLSFormatFile: 'Please upload XLS / xlsx format file!',
  updateSucceeded: 'Update succeeded!',
  failedUpdateSupplierData: 'Failed to update supplier data!',
  industrialAndCommercialInformationQuery: 'Industrial and commercial information query',
  fleetCode: 'Fleet code',
  platformSupplier: 'Platform supplier',
  ouJian: 'Ou Jian',
  supplierPrincipal: 'Supplier principal',
  crossTenantEntrustedBookingGeneralProtocol: 'Cargoware platform cross tenant entrusted booking general protocol',
  traders: 'Traders',
  shortNameCannotBeEmpty: 'Short name cannot be empty',
  oneBusinessTypeForCustomer: 'Select at least one business type for the customer',
  customerAddressNotEmpty: "Customer's address cannot be empty",
  partnerRoleMustBeSelected: 'A partner role must be selected',
  customerBusinessTypeMustBeSelected: "Customer's business type must be selected",
  usedByVoucherCannotModified: 'It has been used by voucher and cannot be modified',
  usedByVoucherAreYouSureModified: 'This partner has already generated a voucher. Are you sure you want to change it?',
  duplicatePartnerCodeAlreadyExists: 'Duplicate partner code already exists, please check the partner code!',
  partnerSameNameAlreadyExists: 'A partner with the same name already exists, please check the Chinese name or English name',
  online: 'Online',
  paper: 'Paper',
  carrierNotSelected: 'Carrier not selected',
  carrierAlreadyExists: 'Carrier already exists',
  bookingMethodNotSelected: 'Booking method is not selected',
  shortMessage: 'short message',
  alreadyDefaultContact: 'There is already a default contact. Saving will take the current contact as the default value',
  notSaveTwoDefaultContact: 'Not to save two default contact!',
  contactNameAndPhoneNumberCannotBlank: 'Contact name and phone number cannot be blank!',
  contactNameCannotBlank: 'Contact name cannot be empty!',
  emailBlankOrFormatError: 'Email is empty or has the wrong format!',
  mobileBlankOrFormatError: 'The mobile phone number is empty or the format is wrong!',
  sameAirlineInvalidMsg: '{0}【{1}】with the same route already has the same 【{2}】, please do not add it again!',
  mailMode: 'Email receiving',
  phoneMode: 'SMS receiving',
  syncContact: 'Sync data to partner contacts',
  currentJob: 'Current job',
  mobilePhoneNumberValidNumber: 'Mobile phone number can only be a valid number',
  emailFormatError: 'Email format error',
  emailLengthCannotExceed128Characters: 'Email length cannot exceed 128 characters',
  phoneNumberLengthCannotExceed32Characters: 'The length of mobile phone number cannot exceed 32 characters',
  phoneNumberCannotLongerThan32Characters: 'The phone number cannot be longer than 32 characters',
  expenseFinancialDate: 'Expense financial date',
  dailySettlement: 'Daily settlement',
  adjustContractInformationInBasicData: 'Your company has opened the contract management menu. Please adjust the contract information within the validity period in the basic data - contract management!',
  masterAgent: 'Master agent',
  secondaryAgent: 'Secondary agent',
  billAddressCannotEmpty: 'Bill address cannot be empty!',
  nmsCannotEmpty: 'NMS cannot be empty!',
  firstPlease: 'First, please',
  selectImportFile: 'Select import file:',
  fileSizeCannotExceed20m: 'The file size cannot exceed 20m',
  startImport: 'Start import',
  emailAddress: 'e-mail address',
  specificContactEmailAddress: 'Specific contact email address',
  userCannotEmpty: 'User cannot be empty!',
  destinationOperationAgentNotMaintained: 'The destination operation agent is not maintained',
  completeInputItems: 'Please complete the input items',
  disassociateAndSaveModifications: 'Are you sure to disassociate and save the modifications?',
  alreadyDefaultBankInformation: 'There is already default bank information. Saving will take the current bank information as the default value',
  ordinary: 'ordinary',
  supervise: 'supervise',
  warehousingRequirements: 'Warehousing requirements',
  alreadyDefaultWarehouse: 'There is already a default warehouse. Saving will take the current warehouse as the default warehouse',
  operateInMasterDataContractManagement: 'Your company has opened the [contract management] menu permission. Please operate in master data - contract management!',
  contract: 'contract',
  effectiveAndExpirationDateCannotBlank: 'Effective date and expiration date cannot be blank',
  fileDeletedSuccessfully: 'File deleted successfully!',
  viewContactInformation: 'View contact information',
  lineAlreadyExistsAndCannotAddedRepeatedly: 'This line already exists and cannot be added repeatedly',
  vendorCannotEmpty: 'Vendor cannot be empty!',
  confirmDeleteSupplyChainLine: 'Are you sure to delete this supply chain line?',
  deleteSupplyChain: 'Delete supply chain',
  emailAddress2: 'e-mail address',
  setDefaultAutoSendMailbox: 'Set as default auto send mailbox',
  alreadyDefaultInvoicingHeader: 'There is already a default Invoicing header. When saving, the current Invoicing header will be used as the default value',
  branchCannotBlank: 'Branch cannot be blank',
  cannotRepeat: 'Cannot repeat',
  bookingAgentNotSelected: 'Booking agent not selected',
  bookingAgentAlreadyExists: 'Booking agent already exists',
  defaultMarkupRange: 'Default markup range',
  rateClass: 'Rate class',
  batchSaveSucceeded: 'Batch save succeeded',
  priceAdjustmentRecordUsedAndCannotDeleted: 'Price adjustment record has been used and cannot be deleted.',
  deleteSucceeded: 'Delete succeeded!',
  selectAppointmentNumberToEdit: 'Please select the appointment number you want to edit!',
  shipSecretaryAppointmentNumberCannotEmpty: "The ship secretary's appointment number cannot be empty!",
  innerContractNoCannotEmpty: 'The inner contract no cannot be empty!',
  effectiveDateCannotBlank: 'Effective date cannot be blank!',
  expirationDateCannotBlank: 'Expiration date cannot be blank!',
  expirationDateMustGreaterEqualEffectiveDate: 'The expiration date must be greater than or equal to the effective date!',
  defaultPriceIncreaseRangeCannotBlank: 'The default price increase range cannot be blank!',
  selectRouteCorrespondingToDestinationPort: 'Please select the route corresponding to the destination port!',
  oneRecordWithoutRouteAndDestination: 'There can only be one record without route and destination!',
  sameRoute: 'Same route',
  oneRecordCanGeneratedPleaseModify: 'Only one record can be generated, please modify!',
  sameRouteAndDestination: 'Same route and destination',
  samePol: 'Same port Of loading',
  associatedRoute: 'Associated Route',
  isParentCompany: 'Parent Company Or Not',
  isFba: 'FBA Or Not',
  subsidiaryInformation: 'Subsidiary Information',
  deleteSubsidiaryTips: 'Please check the subsidiary you want to delete!',
  deleteSubsidiaryConfirm: 'The relationship between parent company and subsidiary company will be dissolved after removal. Do you want to continue?',
  changeParentCompany: 'There is already an associated subsidiary, please cancel the relationship with the subsidiary before operation!',
  officeChangeForSubsidiaryCompany: 'There is already an associated subsidiary. When the modified subsidiary edits the parent company, the partner may not be selected. Do you want to continue?',
  quota: 'quota',
  monthlySpecifiedDate: 'Monthly specified date',
  weeklySettlement: 'Weekly settlement',
  semilunarKnot: 'Semilunar knot',
  settlementDay: 'Settlement by day',
  statementDate: 'statement date',
  customerSupplierType: 'Customer supplier type',
  CustomerMailbox: 'Customer mailbox',
  WhetherToSendMailAutomatically: 'Whether to send mail automatically',
  DefaultMailSendingObject: 'Default mail sending object',
  DefaultMailSendingObjectTip: 'If the email address of the selected email push object is blank, it will be sent to the invoice creator',
  BulkUpdateSurcharge: 'Bulk update surcharge',
  autoEmailSettings: 'Auto email settings',
  taxControlPlatformSending: 'Tax control platform sending',
  systemAutomaticSending: 'System automatic sending',
  systemAutomaticSendingObject: 'System automatic sending object',
  taxControlPlatformSendingObject: 'Tax control platform sending object',
  partnerInvoiceReminder: 'Tax control platform and this system can send emails to designated email addresses separately. If automatic sending is enabled, but the email address of the selected email push object is empty, it will be sent to the invoice creator.',
  interestFreeCompany: 'Interest-free company',
  uniformRenewalSurcharge: 'Uniform renewal surcharge',
  lookSurcharge: 'Look surcharge',
  batchReplaceAfterSave: 'Prompt: After saving, the surcharges previously maintained will be replaced in batches, which will take effect on all routes under the current contract price.',
  validityPeriodRepeatedAndCannotCopy: 'The validity period is repeated and cannot be copied',
  sameRoutePodPol: 'Same route, destination, departure',
  sameRoutePol: 'Same route and departure',
  agreementContent: `Party A: Cross-Tenant Booking Consignor (hereinafter referred to as Party A)
  Party B: Cross-Tenant Booking Recipient (hereinafter referred to as Party B)
  
  Parties A and B adhere to the principle of ""increasing efficiency, reducing links, promoting development, clarifying responsibilities, and standardizing behavior."" In accordance with national and Shanghai municipal laws and regulations, Party B books with Party A through the CARGOWARE platform using electronic booking. The following agreement is reached based on the principle of ""equality and mutual benefit, consensus"":
  
  
  Chapter 1 General Provisions
  
  1. This agreement is a formal universal agreement established by Party A through the CARGOWARE platform for sea export business involved in cross-tenant electronic booking; from the moment Parties A and B agree to this agreement on the CARGOWARE platform, it is deemed that platform users have acknowledged the responsibilities and obligations stipulated in this agreement;
  2. Party A should be a company or enterprise with independent legal personality, legally conducting international freight forwarding business within the business scope listed on the valid business license;
  3. Party B should be a company or enterprise with independent legal personality, legally conducting international freight forwarding business within the business scope listed on the valid business license;
  4. After both Parties A and B are legally registered and audited through the CARGOWARE platform, they obtain the platform enterprise user ID and Key (electronic data signature). Any actions performed on the CARGOWARE platform with this electronic data signature are considered the true intention of both parties, and they acknowledge and are willing to bear all responsibilities and risks arising therefrom;
  5. Party A agrees to apply for booking to Party B in the form of replacing paper booking consignment note with platform cross-tenant electronic booking, and replacing booking stamp with Tenant ID and Key;
  6. Party B replaces the paper booking arrangement receipt with the cross-tenant electronic receipt and confirms the booking in the form of Tenant ID and Key, accepting the consignment of Party A; Party B will arrange for shipment, loading, warehousing, container loading, and a series of freight forwarding business for the shipper or the shipper's agent on behalf of Party A in accordance with the terms of the relevant business agreement between both parties;
  7. The process mechanism and implementation method of cross-tenant electronic booking adopted by Parties A and B are pre-established by the data cloud platform, and both Parties A and B fill in each other's Tenant ID in this function;
  8. Both Parties A and B have the responsibility to prevent illegal intrusion or transmission, ensure that their own senders and receivers have legal authorization, and effectively protect business records and data from illegal intrusion, tampering, or destruction;
  9. Upon receiving Party A's cross-tenant electronic booking application message, Party B should promptly issue a receipt through the platform. Party A should always pay attention to the status of its own electronic booking consignment application. If it does not receive the other party's processing information, Party A has the obligation to contact Party B as soon as possible and find the reason;
  10. If both Parties A and B fail to receive confirmation within a reasonable agreed time, they should take appropriate measures. Otherwise, both parties have the right to assume that the initial transmission has been received. The CARGOWARE platform does not bear any responsibility for the timeliness and validity of the parties' acceptance;
  11. The cross-tenant electronic booking data and receipt information that meet the platform operation specifications of both Parties A and B have the same legal effect as written documents; Party A has the right to claim freight for the goods consigned by Party B.
  
  
  Chapter 2 Fees and Settlement
  
  The business consignment services involved in the cross-tenant electronic booking between Parties A and B are implemented according to the specific terms of the freight forwarding agreement and the relevant fee settlement agreement signed by both parties.
  
  
  Chapter 3 Rights and Obligations of Both Parties
  
  1. If the electronic data signature provided to the CARGOWARE platform is not properly stored due to Party A's reasons, or the authorized operation is not strict, resulting in its use or illegal use and data operation by others, Party A shall bear the corresponding consequences;
  2. The content of the data telegram sent by Party A to Party B or online input in Party A's electronic system should include but is not limited to accurate pre-arranged ship schedules or aircraft flights, carrier names, freight numbers, bill of lading numbers, agreement numbers, destination ports, unloading ports, cargo details (name, pieces, gross weight, volume, description of the properties of the goods, dimensions of special goods, etc.), freight terms, pre-arranged container types and volumes, shipper, consignee, notifier, marks and other information that needs special mention, and should be sent in the form agreed by both parties;
  3. For special goods such as dangerous goods, refrigerated goods, oversized goods, goods that need box inspection or goods that can only be carried in special boxes, and other special goods that Party A needs to provide paper written confirmation letters before they can accept the booking, such as drawing materials of oversized goods and pre-cooling certificates of refrigerated boxes. For dangerous goods, paper-based dangerous goods declaration forms and dangerous goods packing certificates and other documents required by the carrier are also required. For certain goods that need to be paid in advance before booking, they should pay Party B in time, and then they can accept the booking;
  4. Party A should truthfully declare the real information of the consigned goods in the electronic booking message. If Party A's false declaration damages the interests of Party B or a third party, Party A should bear the corresponding damage compensation responsibility;
  5. If Party A needs to change the booking consignment information, it should notify Party B on the day the goods are loaded into the container or the general cargo enters the stack (warehouse); Party A should apply for changes in written form or in other forms agreed by both parties;
  6. Party A has the obligation to pay freight, additional charges and other fees for the goods consigned by Party B through electronic booking consignment at the agreed time;
  7. If Party A needs to withdraw the booked bill of lading, it should promptly notify Party B in written form or in other forms agreed by both parties, otherwise Party B shall bear all responsibilities and costs arising therefrom;
  8. Party B should accept or reject Party A's booking consignment in a timely manner within a reasonable time after receiving the cross-tenant electronic booking sent by Party A in the form of electronic data;
  9. Due to the abnormal failure of their own network, public network or CARGOWARE platform, both parties should use traditional paper booking methods to carry out booking business and transmit information during this period.
  
  
  Chapter 4 Confirmation of Electronic Booking
  
  1. Party B must process the electronic booking data message from Party A in a reasonable time after receiving it, and should send a receipt confirming acceptance or rejection of the commission as required by the platform. If rejected, the reason for rejection should be explained;
  2. Party A can only consider Party B to have accepted the booking commission after Party B returns the electronic booking receipt confirming acceptance of the commission;
  3. If Party A carries out a series of activities that can only be done after Party B accepts Party A's booking before Party B's confirmation, this behavior is considered infringement, and Party A bears all legal responsibility and risk arising from it;
  4. Party B should accept Party A's booking stowage commission on behalf of the carrier according to the confirmed booking content and requirements and handle related export transportation business. Any actions of Party B under this agreement cannot be considered as a promise or guarantee that the confirmed bill of lading can be successfully booked and stowed.
  
  
  Chapter 5 Performance of the Agreement
  
  1. Both Party A and Party B should strictly implement the contents related to this agreement and its clauses.
  2. No party to the agreement may transfer the benefits under this agreement to unrelated individuals or organizations.
  3. If any party to the agreement is unable to perform or unable to perform on time due to force majeure when fulfilling the obligations stipulated in this agreement, it should notify the other party in time and try to adopt other methods. During this period, the party to the agreement is not responsible for any adverse consequences caused by delay, omission, or error in the data message.
  4. If one party to the agreement finds a violation of security, illegal use, or illegal behavior, it should immediately notify the other party and other relevant parties, conduct an investigation, and report the results to the other party and other relevant parties. During this period, electronic data should be temporarily stopped until the safety situation is restored to normal.
  5. If Party A and Party B sign a ""Freight Forwarding Agreement"", this agreement is an attachment to that agreement, and the parts not covered by this agreement are executed according to the relevant clauses of the ""Freight Forwarding Agreement"".
  
  
  Chapter 6 Changes and Termination of the Agreement
  
  1. Neither party to this agreement may unilaterally change or terminate the agreement. If there is a special reason that cannot continue to perform or need to change, it must be agreed by the other party, and the change or termination procedures must be handled within the time stipulated in the agreement. If proposed outside the period specified in the agreement, the party must bear the actual loss caused to the other party.
  2. If both parties agree to terminate this agreement, they should remove the agreement items related to the CARGOWARE platform cross-Tenant commission function and clear the relevant configuration information.
  
  
  Chapter 7 Breach of Contract
  
  If a party violates the agreement, it should compensate according to the actual damage caused to the other party by this behavior.
  
  
  Chapter 8 Others
  
  Any dispute arising from this agreement shall be negotiated and resolved by both parties on the principle of mutual benefit. If the negotiation fails, a lawsuit should be filed in the maritime court where the two parties are registered and operated.`,
  SuccessSyncCloudAndStarrySky: 'Successfully synchronized cloud and starry sky',
  FailSyncCloudAndStarrySky: 'Failed to synchronize the cloud and starry sky,{0}',
  HMSyncYongYouSuccess: 'Customer data synchronization with YongYou successful 。msg "{0}"',
  HMSyncYongYouFail: 'Customer data synchronization with YongYou fail, {0}',
  HMSyncYongYouSuccess2: 'Vendor data synchronization with YongYou successful 。msg "{0}"',
  HMSyncYongYouFail2: 'Vendor data synchronization with YongYou fail, {0}',
  bankEnglishName: 'Bank English Name',
  bankAddress: 'Bank Address',
  bankEnglishAddress: 'Bank English Address',
  EidtBranchNotSameTip: 'Please switch the branch in the upper right corner to the same company as this partner for editing operations.',
  BranchNoPartnerPermission: 'The current branch does not have permission to edit partners!',
  DeleteBranchNotSameTip: 'Please switch the branch in the upper right corner to the same company as this partner for delete operations.',
  operateBranchNotSameTip: 'No operation permissions currently available, Please switch the branch in the upper right corner to the same company as this partner for operations.',
  BranchNoDeletePartnerPermission: 'The current branch does not have permission to delete partners!',
  MergeBranchNotSameTip: 'Please switch the branch in the upper right corner to the same company as this partner for merge operations.',
  BranchNoMergePartnerPermission: 'The current branch does not have permission to merge partners!',
  UnifiedSign: 'Unified signature or not',
  IfRisk: 'If risk',
  customerCode: 'Customer Code',
  supplierCode: 'Supplier Code',
  customerCodeNotSupportChinese: 'customer Code Not Support Chinese',
  supplierCodeNotSupportChinese: 'supplier Code NotSupport Chinese',
  CustomersAndSuppliersMustChooseOne: 'Customers and suppliers must choose one',
  CustomerCodeNotEmpty: 'Customer code cannot be empty',
  SupplierCodeNotEmpty: 'Supplier code cannot be empty',
  CustomerCodeCheck: 'The format of the new generation customer code is incorrect. Please enter [13 digits]',
  SupplierCodeCheck: 'The format of the new generation supplier code is incorrect. Please enter [ABCD any letter+7 digits]',
  CcGroup: 'CC Group',
  CcAddress: 'CC Address',
  ccAgentOverseaOp: 'CC agent corresponds to overseas customer service',
  UseEmailGroup: 'Using email groups',
  PartnersApprovedTips: 'The currently selected data contains items that have been approved and cannot be edited. Please uncheck and continue with the operation',
  isInternalCorrespondent: 'Is it an internal company transaction',
  internalCorrespondent: 'Internal communication company',
  batchAddServer: 'Batch addition of service personnel',
  batchAddServerNoSelected: 'Please select the partner to which you want to add service personnel',
  batchAddServerConfigError: 'The partner you selected does not support maintenance service personnel',
  addServicePersonnel: 'New service personnel',
  BookingAgentLevel: 'Booking Agent Level',
  bookingAgentLevelNotSelected: 'Booking Agent Level not selected',
  Underestimation: 'Underestimation',
  IfAdvancePayment: 'Advance Payment',
  CreditRemarks: 'Additional Explanation for Credit Accounts',
  DefaultSettlementForInsurance: 'Default settlement object for insurance',
  DriverInformation: 'Driver inforMation',
  DriverName: 'Driver name',
  DriverPhoneNumber: 'Driver phone number',
  PlateNumber: 'Plate number',
  IdentityCard: 'identity card',
  DriverNameRequired: 'Driver name required',
  CreditUnit: 'credit unit',
  creditDateUnit: 'credit date unit',
  b2bDisplay: 'B2B Display'
}
